import { Injectable } from '@angular/core';
import { currency } from 'i2g-rosetta';
import { LocalizationService } from '../../../localization/localization.service';
import { EnvironmentsEnum } from '../../../../../environments/environments.enum';
import { environment } from '../../../../../environments/environment';

export interface ICurrencyInfo {
  symbol: string;
  decimalDigits: number;
  code: string;
}

@Injectable()
export class MoneyService {
  constructor(private _localizationService: LocalizationService) {}

  getCurrencyInfo(currencyCode: string = 'USD'): ICurrencyInfo {
    const currencyInfo = currency.getCurrency(currencyCode);

    if (currencyInfo) {
      return {
        symbol: currencyInfo.symbol || '',
        decimalDigits: currencyInfo.digits,
        code: currencyInfo.code,
      };
    } else {
      return null;
    }
  }

  formatInSuperUnit(
    amountInSubUnit: number,
    currencyCode: string = 'USD',
    locale: string = 'en_US'
  ): string {
    const superUnit = this.subToSuperUnit(amountInSubUnit, currencyCode);
    return this.format(superUnit, currencyCode, locale);
  }

  /**
   * Format a number to currency
   *
   * @param amount (should be in superunit format)
   * @param currencyCode - Currency code
   * @param locale (locale for the currency format)
   */
  format(
    amount: number,
    currencyCode: string = 'USD',
    locale: string = 'en_US'
  ): string {
    return this._format(amount, currencyCode, locale);
  }

  subToSuperUnit(amount: any, currencyCode: string) {
    return currency.subToSuperUnit(parseFloat(amount) || 0, currencyCode);
  }

  superToSubUnit(amount: any, currencyCode: string) {
    return currency.superToSubUnit(parseFloat(amount) || 0, currencyCode);
  }

  private _format(
    amount: number,
    currencyCode: string = 'USD',
    locale: string = 'en_US'
  ): string {
    const formattedLocale = this._localizationService.getFormattedLocale(
      locale
    );

    try {
      const formatter = global.Intl.NumberFormat(formattedLocale, {
        style: 'currency',
        currency: currencyCode,
      });

      return formatter.format(amount);
    } catch (e) {
      if (environment.env !== EnvironmentsEnum.production) {
        console.error(e);
      }

      return '';
    }
  }
}
